import { Link as RouterLink, Outlet, Navigate, useParams, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Logo from "../components/Logo";
import { member_init_without_token } from "src/DAL/ContentSetting/ContentSetting";
import { useEffect, useState } from "react";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { CircularProgress } from "@mui/material";

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: "fit-content",
  position: "absolute",
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(5, 5, 0),
  },
  [theme.breakpoints.down("md")]: {
    width: "150px",
  },
}));

export default function LogoOnlyLayout() {
  const { slug } = useParams();
  const { pathname } = useLocation();

  const { handleStripeKey, handleProjectInfo } = useContentSetting();
  const [isLoadingApp, setIsLoadingApp] = useState(false);


  const handleGetContentData = async (slug) => {
    const localPageContent = localStorage.getItem("page_content");
    const localProjectInfo = localStorage.getItem("project_info");
    // dont call api on forget password page if localstorage have data
    if (pathname.includes("forget_password") && localPageContent && localProjectInfo) {
      const parsedProjectInfo = JSON.parse(localProjectInfo);
      handleProjectInfo(parsedProjectInfo);
      return;
    }
    // --------------------------------------------------------------

    const postData = {
      slug: slug,
      type: "member"
    }
    setIsLoadingApp(true);
    const result = await member_init_without_token(postData);
    if (result.code === 200) {
      const setting = result?.content_setting?.client_content_setting || {};
      const general_setting = result?.content_setting?.client_general_setting || {};
      const site_setting = result?.site_setting || {};

      localStorage.setItem(`page_content`, JSON.stringify(setting));
      localStorage.setItem(`project_info`, JSON.stringify(general_setting));

      if (Object.keys(general_setting).length > 0) {
        handleProjectInfo(general_setting);
      }

      if (site_setting.stripe_mode === "sandBox") {
        handleStripeKey(site_setting.sandBox_publish_key || "");
      } else {
        handleStripeKey(site_setting.live_publish_key || "");
      }
    } else {
      setIsLoadingApp(false);
    }
    setIsLoadingApp(false);
  };

  useEffect(() => {
    if (slug) {
      localStorage.setItem("slug", slug);
    }
    handleGetContentData(slug || localStorage.getItem("slug"));

  }, [slug]);

  if (isLoadingApp) {
    return (
      <>
        <CircularProgress className="centered" color="primary" />
      </>
    );
  }

  // if slug in localstorage navigate to slug based link 
  const storedSlug = localStorage.getItem("slug");
  if (!slug && storedSlug) {
    if (pathname.includes("/login")) {
      return <Navigate to={`/login/${storedSlug}`} />;
    }
  }

  if (localStorage.getItem("token")) {
    return <Navigate to="/dashboard"> </Navigate>;
  }

  return (
    <>
      <HeaderStyle>
        <RouterLink to={storedSlug ? `/login/${storedSlug}` : "/login"}>
          <Logo />
        </RouterLink>
      </HeaderStyle>
      <Outlet />
    </>
  );
}
